import React, { useState } from "react";
import "./App.css";
import Question from "./components/Question.js";
import NextQuestion from "./components/NextQuestion.js";
import data from "./sample_data.json";

function App() {
  const [answerState, setAnswerState] = useState(null);
  const [currentQuestionNum, setCurrentQuestionNum] = useState(0);

  function getCorrectAnswer(questionNum) {
    let currentQuestion = data[questionNum].question;
    let correctChoiceIndex = currentQuestion.correct_choice_index;
    return currentQuestion.choices[correctChoiceIndex];
  }

  function questionAnswered() {
    if (answerState === null) {
      return <p className="prompt">Click an answer above</p>;
    } else if (answerState === getCorrectAnswer(currentQuestionNum)) {
      return (
        <p className="prompt">You chose {answerState}. That is correct!</p>
      );
    } else {
      return (
        <p className="prompt">You chose {answerState}. That is incorrect.</p>
      );
    }
  }

  function goToNextQuestion() {
    setCurrentQuestionNum(currentQuestionNum + 1);
    setAnswerState(null);
  }

  return (
    <div className="app">
      <h1 className="title">Trivia!</h1>
      <Question
        question={data[currentQuestionNum].question.text}
        choices={data[currentQuestionNum].question.choices}
        setAnswerState={setAnswerState}
      />
      {questionAnswered()}
      <NextQuestion
        currentQuestionNum={currentQuestionNum}
        goToNextQuestion={goToNextQuestion}
      />
      {/*EXTENSION: {currentQuestionNum < data.length - 1 && answerState !== false ? (
        <NextQuestion nextQuestion={nextQuestion} />
      ) : (
        <p></p>
      )} */}
    </div>
  );
}

export default App;
